var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/validation-checkmark.tsx";
import classNames from 'clsx';
import React from 'react';
import { HStack, Icon, Text } from 'soapbox/components/ui';

const ValidationCheckmark = _ref => {
  let {
    isValid,
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 2,
    "data-testid": "validation-checkmark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: isValid ? require('@tabler/icons/check.svg') : require('@tabler/icons/point.svg'),
    className: classNames({
      'w-4 h-4': true,
      'text-gray-400 dark:text-gray-600 dark:fill-gray-600 fill-gray-400': !isValid,
      'text-success-500': isValid
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, text));
};

export default ValidationCheckmark;